import { call, fork, put, takeLatest, select } from 'redux-saga/effects';
import { get } from 'lodash';

import {
	EMAIL_VERIFICATION,
	ACTIVATE_PAYMENT_SOLUTION,
	SERVICE_LINE_LIST_SUCCESS,
	SERVICE_LINE_LIST_ERROR,
	SERVICE_LINE_LIST_REQUESTING,
} from '@/online-merchant-onboarding/redux/ducks/onboarding/type';
import ApiService from '@/online-merchant-onboarding/services/ApiService';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';
import handleError from '@/utils/helper';
import {
	userDataSelector,
	merchantIdSelector,
} from '@/online-merchant-onboarding/redux/ducks/onboarding/selectors';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';

function* handleGetServiceLineList(params) {
	try {
		const merchantId =
			params && params.data ? params.data : yield select(merchantIdSelector);
		const response = yield call(ApiService.getServiceLinesList, merchantId);
		yield put({ type: SERVICE_LINE_LIST_SUCCESS, data: response.data.data });
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error });
		} else {
			const errorResponse = yield call(handleError, error);
			yield put({
				type: SHOW_TOAST,
				payload: {
					msg: errorResponse.msg || 'Something went wrong',
					type: 'error',
				},
			});
			yield put({
				type: SERVICE_LINE_LIST_ERROR,
				error,
			});
		}
	}
}

function* serviceLineListWatcher() {
	yield takeLatest(SERVICE_LINE_LIST_REQUESTING, handleGetServiceLineList);
}

function* handlePaymentSolutionActivation(params) {
	try {
		const merchantId = yield select(merchantIdSelector);
		yield call(ApiService.initServiceLine, {
			merchantId,
			solutionType: params.payload,
		});
		yield call(handleGetServiceLineList);
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error });
		} else {
			const errorResponse = yield call(handleError, error);
			yield put({
				type: SHOW_TOAST,
				payload: {
					msg: errorResponse.msg || 'Something went wrong',
					type: 'error',
				},
			});
		}
	}
}

function* paymentSolutionActivationWatcher() {
	yield takeLatest(ACTIVATE_PAYMENT_SOLUTION, handlePaymentSolutionActivation);
}

export function* handleEmailVerifier() {
	try {
		const user = yield select(userDataSelector);

		const response = yield call(ApiService.emailVerification, {
			userGroupNamespaceId: user.groupId,
			userId: user.userId,
			type: 'EMAIL_SIGNUP',
		});
		yield put({
			type: SHOW_TOAST,
			payload: {
				msg: response.msg || 'Verification email sent',
				type: 'success',
			},
		});
	} catch (error) {
		yield put({
			type: SHOW_TOAST,
			payload: {
				msg: get(error, 'data.message'),
				type: 'error',
			},
		});
	}
}

export function* emailVerificationWatcher() {
	yield takeLatest(EMAIL_VERIFICATION, handleEmailVerifier);
}

function* onboardingFlowSaga() {
	yield fork(emailVerificationWatcher);
	yield fork(paymentSolutionActivationWatcher);
	yield fork(serviceLineListWatcher);
}

export default onboardingFlowSaga;
